import { AnyAction, Dispatch } from 'redux'

import routes from '@routes/routes'
import { contratacaoRequest } from '@store/refinanciamento/contratacao/actions'
import { getPropostasRequest } from '@store/refinanciamento/proposta/actions'
import { MarginErrorCodes } from '@utils/enums'

const PROPOSAL_REQUEST_DELAY_MS = 11000

export interface RefinSolicitarContratacaoFlowInput {
  numberOfInstallments: number
  hasInsurance: boolean
  convenioName?: string
  onComplete: () => void
  onError: () => void
  navigate: (path: string, options?: { state?: Record<string, unknown> }) => void
}

export const dispatchRefinSolicitarContratacaoFlow = (
  dispatch: Dispatch<AnyAction>,
  input: RefinSolicitarContratacaoFlowInput,
): void => {
  dispatch(
    contratacaoRequest({
      numberOfInstallments: input.numberOfInstallments,
      hasInsurance: input.hasInsurance,
      callback: () => {
        setTimeout(() => {
          dispatch(
            getPropostasRequest({
              callback: (data) => {
                input.onComplete()
                if (
                  data?.errorCode === MarginErrorCodes.DISQUALIFIED_CROSS_CS007 ||
                  data?.errorCode === MarginErrorCodes.DISQUALIFIED_CROSS_CS008
                ) {
                  input.navigate(routes.DESQUALIFICACAO, {
                    state: {
                      convenioNameLocation: input.convenioName,
                      step: 'desqualificacao-proposta',
                    },
                  })
                  return
                }

                input.navigate(routes.CARREGAMENTO_FORMALIZACAO)
              },
              errorCallback: input.onError,
            }),
          )
        }, PROPOSAL_REQUEST_DELAY_MS)
      },
      errorCallback: input.onError,
    }),
  )
}
